$(function() {

	"use strict";

	$("#sd-wrap-form").on("submit", "form:not(.base64)", function(event){
		var form = $(this);
		var mydata = form.formData({
			select_attr : 'name',
			textvalue   : false,
			callback    : false,
		});
		mydata['sendUrl'] = form.attr('action');
		form.find('input[data-split]').each(function(){
			var devider = $(this).data('split');
			var name = $(this).attr('name');
			var value = $(this).val();
			if(value.indexOf(devider) !== -1){
				var splitVal = value.split(devider).filter(String);
			}else{
				var splitVal = value;
			}
			mydata[name] = splitVal;
		});


		if(!mydata['auth']){
			cleanObj(mydata);
		}


		$.ajax({
			type: "POST",
			dataType: "json",
			crossDomain: false,
			cache: false,
			url: basisProxyUrl,
			data: mydata,
			success: function(data) {
				var result = JSON.stringify(data, "", 4)
				$("textarea.ebs-textarea").val(result);
				if(data.excerpt_body){
					$("input.h-base64").val(data.excerpt_body);
				}
			},
			error: function(xhr, textStatus, errorThrown) {
				console.log(xhr);
			}
		});
		return false;
	});


	$("#sd-wrap-form").on("input change", "form", function(event){
		var form = $(this);
		makeWatchRequest(form);
	});

	$("#sd-wrap-form").on({
		mouseenter: function () {
			var form = $(this).parents("form");
			makeWatchRequest(form);
		},
		mouseleave: function () {
			
		}
	}, "button[data-clearform]");


	function cleanObj(obj) {
		for (var propName in obj) { 
			if (obj[propName] === null || obj[propName] === undefined || obj[propName] == "") {
				delete obj[propName];
			}
			delete obj['typel'];
		}
	}


	function workForm(form) {

		console.log(form);
		return fomData;
	}

	function makeWatchRequest(form) {

		// обработка фин селекта, в поиске фирм
		// ТОДО
		// вынести куданить
		var fin = $("select[data-fin='select']").val();
		if(fin !== "0"){
			$("[data-fin='from']").attr("name",fin + ".from");
			$("[data-fin='to']").attr("name",fin + ".to");
			$("[data-fin='years']").attr("name",fin + ".years");
		}

		var fomData = form.formData({
				select_attr : 'name',
				textvalue   : false,
				callback: false,
			});

		
		// обработка сплитов
		// ТОДО вынести в функцию, и заюзать в отправке формы 
		form.find('input[data-split]').each(function(){
			var devider = $(this).data('split');
			var name = $(this).attr('name');
			var value = $(this).val();
			if(value.indexOf(devider) !== -1){
				var splitVal = value.split(devider).filter(String);
			}else{
				var splitVal = value;
			}
			fomData[name] = splitVal;
		});

		// сводные данные
		if(fomData['typel']){
			var typeL = fomData['typel'];
			var actionform = $("input[name='typel']:checked").data('formaction');
			var ogrn = $("input[name='typel']:checked").data('ogrn');
			var ogrnlabel = $("input[name='typel']:checked").data('ogrnlabel');
			form.attr("action", actionform);
			form.find("input[data-extname='ogrn']").attr("name", ogrn);
			form.find("[data-ogrnlabel='ogrn']").html(ogrnlabel);
			fomData = form.formData({select_attr : 'name'}); }


		if(!fomData['auth']){
			cleanObj(fomData);
		}else{
			delete fomData['auth'];
		}

		var requestUrl = form.attr('action');
		var srtFomData = decodeURIComponent($.param(fomData));
		var srtFomData = unescape(srtFomData);
		var watchRequest = requestUrl + "?"+ srtFomData;
		$("#watch-request").val(watchRequest);
		// return form;
	}

$("#sd-wrap-form").on("click", "button[data-customaction]", function(){
	var form = $(this).parents("form");
	var newAction = $(this).data('customaction');
	form.attr('action', newAction);
	makeWatchRequest(form);
});

$("#sd-wrap-form").on("input change", "input[data-somedis='toggle']", function(){
	var disSwitch = $(this).prop("checked");
	if(disSwitch === true){
		$("[data-somedis='offer']").prop('disabled', true);
	}else{
		$("[data-somedis='offer']").prop('disabled', false);
	}
});

$('input[data-mask]').mask("0000-00-00");



// $(".base64").on("click", function(){
$("#sd-wrap-form").on("submit", "form.base64", function(event){
	var base64 = $("input.h-base64").val();
	if(base64 == ""){
		$("#ebs-textarea").attr("placeholder","Чтобы сохранить, необходимо получить ответ от сервера по номеру заказа");
		return false;
	}
	// $("input.h-base64").val(base64);
});



}(jQuery, window, document));
